import PageStatistics from "./PageStatistics";

export default PageStatistics;
